import { apiSlice } from '../api/apiSlice';
import { SMSBodyProps, SMSProps } from './sms.types';

export const smsApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => {
    return {
      getSMS: build.query<
        { smsArray: SMSProps[]; totalCount: number },
        { limit: number; pageNo: number; patientId: string }
      >({
        query: ({ limit, pageNo, patientId }) => ({
          params: {
            limit,
            pageNo
          },
          url: `/sms/${patientId}/history`
        }),
        transformResponse: (response: { data: SMSProps[]; info: { totalCount: number } }) => ({
          smsArray: response.data,
          totalCount: response.info.totalCount
        })
      }),
      sendSMS: build.mutation<SMSProps, { body: SMSBodyProps; patientId: string }>({
        query: ({ body, patientId }) => ({
          body: body,
          method: 'POST',
          url: `/sms/${patientId}/send`
        }),
        transformResponse: (response: { data: SMSProps }) => response.data
      })
    };
  }
});

export const { useLazyGetSMSQuery, useSendSMSMutation } = smsApiSlice;
